import '@/scss/page-templates/home.scss';

console.log('home.ts');



